module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('demonstration', {
    attrs: {
      "tag": "h2",
      "title": "Icon 图标",
      "anchor": "icon-tu-biao",
      "description": "图标组件",
      "show-content": false
    }
  }), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "概述",
      "anchor": "gai-shu",
      "show-content": false
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n      图标使用开源项目 "), _c('a', {
    attrs: {
      "href": "http://ionicons.com/",
      "target": "_blank"
    }
  }, [_vm._v("ionicons")])])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "使用方法",
      "anchor": "shi-yong-fang-fa",
      "multiple": true,
      "highlight": _vm.sourcecode
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n      为图标指定对应的 "), _c('code', [_vm._v("type")]), _vm._v(" 属性\n    ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "vd-demo__block vd-demo__block-1"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("默认，heart")]), _vm._v(" "), _c('div', [_c('vm-icon', {
    attrs: {
      "type": "heart"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-1"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("指定颜色，#FF4949")]), _vm._v(" "), _c('div', [_c('vm-icon', {
    attrs: {
      "type": "heart",
      "color": "#FF4949"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-1"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("指定大小，默认单位px")]), _vm._v(" "), _c('div', [_c('vm-icon', {
    attrs: {
      "type": "heart",
      "size": 30
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-1"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("带单位，em")]), _vm._v(" "), _c('div', [_c('vm-icon', {
    attrs: {
      "type": "heart",
      "size": "2em"
    }
  })], 1)])]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n      通过为组件指定 "), _c('code', [_vm._v("type")]), _vm._v(" 属性，最终渲染为 "), _c('code', [_vm._v("i class=\"vm-icon-heart\"")]), _vm._v("，可以指定 "), _c('code', [_vm._v("size")]), _vm._v("\n      属性，为图标设置大小。还可以指定 "), _c('code', [_vm._v("color")]), _vm._v(" 属性，为图标指定颜色。当然提供 "), _c('code', [_vm._v("size")]), _vm._v(" 和 "), _c('code', [_vm._v("color")]), _vm._v("\n      只是提供了方便，你可以直接在组件上设置style 属性， "), _c('code', [_vm._v("style=\"font-size: 2em; color: red;\"。")])])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "Attributes",
      "anchor": "attributes",
      "show-content": false
    }
  }, [_c('template', {
    slot: "table"
  }, [_c('table', {
    staticClass: "vd-demo__table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("属性")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("tag")]), _vm._v(" "), _c('td', [_vm._v("自定义元素标签")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("*")]), _vm._v(" "), _c('td', [_vm._v("i")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_vm._v("图标的名称")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("size")]), _vm._v(" "), _c('td', [_vm._v("图标的大小，单位是 %, in, cm, mm, em, ex, pt, pc, px 之一， 默认单位为 px")]), _vm._v(" "), _c('td', [_vm._v("number/string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("color")]), _vm._v(" "), _c('td', [_vm._v("图标的颜色")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])])])])])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "图标集合",
      "anchor": "tu-biao-ji-he",
      "show-content": false
    }
  }, [
    [_c('div', {
      staticClass: "icon-search"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.keyword),
        expression: "keyword"
      }],
      attrs: {
        "type": "text",
        "placeholder": "输入英文关键词搜索，比如 heart"
      },
      domProps: {
        "value": (_vm.keyword)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.keyword = $event.target.value
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v("点击下面的图标按钮可以直接复制组件代码")])]), _vm._v(" "), _c('div', {
      staticClass: "icons"
    }, [_vm._l((_vm.icons), function(icon, index) {
      return _c('div', {
        staticClass: "icons-item",
        on: {
          "click": function($event) {
            _vm.handleClickIcon(icon, index, $event)
          },
          "mouseleave": function($event) {
            _vm.handleMouseleave()
          },
          "mousemove": function($event) {
            _vm.handleMousemove(icon, index)
          }
        }
      }, [_c('i', {
        class: 'vm-icon-' + icon.name,
        staticStyle: {
          "font-size": "32px"
        }
      }), _vm._v(" "), _c('p', [_vm._v(_vm._s(icon.name))])])
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "copy"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showCopy),
        expression: "showCopy"
      }],
      staticClass: "copied",
      style: ({
        top: _vm.top,
        left: _vm.left
      })
    }, [_vm._v("Copied!")])])], 2)]
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-f5bb25ae", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-f5bb25ae","hasScoped":false}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./example/src/App.vue
// module id = 13
// module chunks = 0